var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Content Block")]),(_vm.parent)?_c('button',{on:{"click":_vm.removeFromParent}},[_vm._v("x")]):_vm._e(),_c('div',[_vm._v("size: "+_vm._s(_vm.item.length))]),_c(_vm.blockComponent,{tag:"component",attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }